import {
  useEffect,
  useRef,
  useState
} from "react";
import { FormHandles } from "@unform/core";
import {
  faChevronLeft, faDownload,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Panel from "../../../../components/Panel";
import {
  ButtonDownloadArch,
  ContainerButton2,
  Form,
  Input,
  TextTitle,
  Textarea,
  Title
} from '../../../../styles/global';
import {
  SubTitle,
} from "../styles";
import Radio from "../../../../components/InputRadio";
import SecondaryTable from "../../../../components/SecondaryTable";
import { GridColDef } from "@mui/x-data-grid";
import useAteste from "../../../../actions/cruds/Financeiro/useAteste";
import { Link, useParams } from "react-router-dom";
import { Button, Container } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import { formatarData, formatarReais } from "../../../../utils/formatDados";
import useInstrumento from "../../../../actions/cruds/InstrumentoContratual/useInstrumento";
import useProcesso from "../../../../actions/cruds/Processos/useProcesso";

const FinanceiroAtesteView: React.FC = () => {
  const { atesteId } = useParams();
  const { ateste, getAteste } = useAteste();
  const { instrumento, getInstrumento } = useInstrumento();
  const { processo, getProcesso } = useProcesso();

  const [valueTipoConta, setValueTipoConta] = useState<String>('');

  useEffect(() => {
    getAteste(atesteId);
  }, []);

  useEffect(() => {
    if (ateste.id) {
      const tipoContaUsuario = optionsAccountType.filter(tipo => tipo.value === ateste.banco_tipo_conta);
      setValueTipoConta(tipoContaUsuario.length ? tipoContaUsuario[0].label : '');
      formRef.current?.setFieldValue("tipo_pagamento", ateste.tipo_pagamento);
      getInstrumento(ateste?.contractual_instrument?.id);
    }

  }, [ateste]);

  useEffect(() => {
    if (instrumento?.id) {
      if (instrumento?.law_process?.id) {
        getProcesso(instrumento?.law_process?.id);
      }
    };

  }, [instrumento]);

  const organizeDataCertidao = (data) => {
    if (typeof data === 'object') {
      data = data.map(d => ({
        id: d.id,
        supplier_id: d.supplier_id,
        nome: d.nome,
        tipo: d.tipo,
        data_vencimento: formatarData(d.data_vencimento, false),
        descricao: d.descricao,
        status_certidao: d.status_certidao,
        arquivo: `${d.url_arquivo}/${d.nome_arquivo}`
      }));
    }
    return data;
  };

  const organizeDataLinhas = (data) => {
    if (typeof data === 'object') {
      if (Object.keys(data).length > 0) {
        data = data.map(d => ({
          id: d.id,
          contrato: d?.contractual_instrument_budget?.project_line?.management_contract?.nome_completo,
          comite: d?.contractual_instrument_budget?.project_line?.comittee?.nome,
          codigo_contabil: `${d?.contractual_instrument_budget?.project_line?.expense_type?.codigo}.${d?.contractual_instrument_budget?.project_line?.organization?.codigo.padStart(2, '0')}.${d?.contractual_instrument_budget?.project_line?.management_contract?.codigo.padStart(2, '0')}.${d?.contractual_instrument_budget?.project_line?.comittee?.codigo.padStart(2, '0')}.${d?.contractual_instrument_budget?.project_line?.unit?.codigo.padStart(2, '0')}.${d?.contractual_instrument_budget?.project_line?.pap_finality?.codigo.padStart(2, '0')}.${d?.contractual_instrument_budget?.project_line?.pap_program?.codigo.padStart(2, '0')}.${d?.contractual_instrument_budget?.project_line?.pap_action?.codigo.padStart(2, '0')}.${d?.contractual_instrument_budget?.project_line?.poa_sub_action?.codigo.padStart(2, '0')}.${processo?.project?.id?.toString().padStart(2, '0')}.${d?.contractual_instrument_budget?.project_line?.description?.codigo.padStart(3, '0')}`,
          valor: formatarReais(d.valor),
          percentual: `${d.percentual}%`,
        }));
        return data;
      }
    }
    return [];
  };

  const organizeDataNotaFiscal = (data) => {
    if (typeof data === 'object') {
      if (Object.keys(data).length > 0) {
        data = data.map(d => ({
          id: d.id,
          contrato: d.management_contract.nome_completo,
          documento_fiscal: d.documento_fiscal,
          valor: formatarReais(d.valor),
          tipo_documento: d.tipo,
          dataDocumento: formatarData(d.data, false),
          url_arquivo: `${d.url_arquivo}/${d.nome_arquivo}`,
          attest_budgets: d.attest_budgets,
        }));

        data.forEach((data) => {
          let codigo = [];
          let linhasConcatenadas;

          data.attest_budgets?.forEach((inv, index) => {
            codigo.push(organizeDataAttestBudget(inv))
            linhasConcatenadas = codigo.map(objeto => objeto.linha).join('\n');
          });

          data.linhas = linhasConcatenadas;
        });

        return data;
      }
    }
    return [];
  };

  const organizeDataAttestBudget = (data) => {
    if (typeof data === 'object') {
      if (Object.keys(data).length > 0) {
        return {
          linha: `${data?.contractual_instrument_budget?.project_line?.expense_type?.codigo}.${data?.contractual_instrument_budget?.project_line?.organization?.codigo.padStart(2, '0')}.${data?.contractual_instrument_budget?.project_line?.management_contract?.codigo.padStart(2, '0')}.${data?.contractual_instrument_budget?.project_line?.comittee?.codigo.padStart(2, '0')}.${data?.contractual_instrument_budget?.project_line?.unit?.codigo.padStart(2, '0')}.${data?.contractual_instrument_budget?.project_line?.pap_finality?.codigo.padStart(2, '0')}.${data?.contractual_instrument_budget?.project_line?.pap_program?.codigo.padStart(2, '0')}.${data?.contractual_instrument_budget?.project_line?.pap_action?.codigo.padStart(2, '0')}.${data?.contractual_instrument_budget?.project_line?.poa_sub_action?.codigo.padStart(2, '0')}.${processo?.project?.id?.toString().padStart(2, '0')}.${data?.contractual_instrument_budget?.project_line?.description?.codigo.padStart(3, '0')}`,
        };
      }
    }
    return [];
  };

  const formRef = useRef<FormHandles>(null);

  const optionsAccountType = [
    { value: "corrente", label: "Conta Corrente" },
    { value: "poupanca", label: "Conta Poupança" }
  ];

  const tipoDocumentoFiscalOptions = [
    { value: "Nota Fiscal", label: "Nota Fiscal" },
  ];

  const tipoPagamentoOptions = [
    { id: "Depósito", value: "Depósito", label: "Depósito" },
    { id: "Boleto/Fatura", value: "Boleto/Fatura", label: "Boleto/Fatura" }
  ];

  const dataTitleLinhas: GridColDef[] = [
    { field: "contrato", headerName: "Contrato de gestão", flex: 2 },
    { field: "comite", headerName: "Comitê", flex: 2 },
    { field: "codigo_contabil", headerName: "Código Contábil", flex: 3 },
    { field: "valor", headerName: "Valor", flex: 1 },
    { field: "percentual", headerName: "Percentual", flex: 1 },
  ];

  const dataTitleCertidao: GridColDef[] = [
    { field: "nome", headerName: "Documento", flex: 2 },
    { field: "data_vencimento", headerName: "Data de vencimento", flex: 2 },
    { field: "status_certidao", headerName: "Status", flex: 2 },
    {
      field: "action",
      headerName: "Documento",
      sortable: false,
      flex: 1,
      renderCell: (params) => {
        return (
          <Link to={{ pathname: params.row.arquivo }} target="_blank">
            <Button variant="text">
              <FontAwesomeIcon icon="fa-solid fa-file-arrow-down" />
            </Button>
          </Link>
        );
      }
    }
  ];
  const dataTitleNotaFiscal: GridColDef[] = [
    { field: "contrato", headerName: "Contrato de Gestão", flex: 2 },
    { field: "linhas", headerName: "Linhas", flex: 2 },
    { field: "dataDocumento", headerName: "Data", flex: 1 },
    { field: "tipo_documento", headerName: "Tipo", flex: 1 },
    { field: "documento_fiscal", headerName: "Documento Fiscal", flex: 1 },
    { field: "valor", headerName: "Valor", flex: 1 },
    {
      field: "action",
      headerName: "Documento",
      sortable: false,
      flex: 1,
      renderCell: (params) => {
        return (
          <Link to={{ pathname: params.row.url_arquivo }} target="_blank">
            <Button variant="text">
              <FontAwesomeIcon icon="fa-solid fa-file-arrow-down" />
            </Button>
          </Link>
        );
      }
    }
  ];

  return (
    <Container>
      <Form id="formAteste" ref={formRef}>
        <Title color='#333'>
          <span>Visualizar Formulário de ateste</span>
        </Title>

        <Panel titulo="Identificação">
          <Grid container spacing={6}>
            <Grid xs={6}>
              <TextTitle>Número do Instrumento:</TextTitle>
              <Input name="numero_contrato" type="text" value={ateste.contractual_instrument?.numero} disabled />
            </Grid>
            <Grid xs={6}>
              <TextTitle>Número do Processo: <span>*</span></TextTitle>
              <Input
                type="text"
                name="numero_processo"
                value={instrumento?.law_process?.id ? `${instrumento.law_process?.codigo} - SIGAD (${instrumento.law_process?.numero})` : ""}
                disabled
              />
            </Grid>
            <Grid xs={6}>
              <TextTitle>Modalidade da contratação: <span>*</span></TextTitle>
              <Input name="modalidade_contratacao" type="text" value={ateste.contractual_instrument?.tipo_instrumento} disabled />
            </Grid>
            <Grid xs={12}>
              <SubTitle>Ordenadores de Despesa: (NI nº 1620/2021) </SubTitle>
            </Grid>
            <Grid xs={6}>
              <TextTitle>Ordenador 01: <span>*</span></TextTitle>
              <Input
                type="text"
                name="ordenador1_id"
                value={ateste.ordenador1?.nome}
                disabled
              />
            </Grid>
            <Grid xs={6}>
              <TextTitle>Ordenador 02: <span>*</span></TextTitle>
              <Input
                type="text"
                name="ordenador2_id"
                value={ateste.ordenador2?.nome}
                disabled
              />
            </Grid>
          </Grid>
        </Panel>

        <Panel titulo="Dados do contrato">
          <Grid container spacing={6}>
            <Grid xs={6}>
              <TextTitle>Data de início do contrato:</TextTitle>
              <Input type="date" name="data_inicio_vigencia" value={instrumento?.data_inicio_vigencia} disabled />
            </Grid>
            <Grid xs={6}>
              <TextTitle>Data de término do contrato:</TextTitle>
              <Input type="date" name="data_termino_vigencia" value={instrumento?.data_termino_vigencia} disabled />
            </Grid>
            <Grid xs={4}>
              <TextTitle>Valor do contrato:</TextTitle>
              <Input type="text" name="valor_total" value={formatarReais(instrumento?.valor_total)} disabled />
            </Grid>
            <Grid xs={4}>
              <TextTitle>Desembolso:</TextTitle>
              <Input type="text" name="desembolso" disabled />
            </Grid>
            <Grid xs={4}>
              <TextTitle>Saldo do contrato:</TextTitle>
              <Input type="text" name="saldo_contrato" disabled />
            </Grid>
          </Grid>
        </Panel>

        <Panel titulo="Dados da Empresa">
          <Grid container spacing={6}>
            <Grid xs={12}>
              <TextTitle>Empresa: <span>*</span></TextTitle>
              <Input
                type="text"
                id="supplier_id"
                name="supplier_id"
                value={ateste.supplier?.nome_razao_social}
                disabled
              />
            </Grid>
            <Grid xs={6}>
              <TextTitle>CPF/CNPJ:</TextTitle>
              <Input name="supplier_cpf_cnpj" type="text" value={ateste.supplier?.cpf_cnpj} disabled />
            </Grid>
            <Grid xs={6}>
              <TextTitle>Pagamento: <span>*</span></TextTitle>
              <Radio
                name="tipo_pagamento"
                options={tipoPagamentoOptions}
                disabled
              />
            </Grid>
            {ateste.tipo_pagamento == 'Boleto/Fatura' ? (
              <>
                <Grid xs={6}>
                  <TextTitle>Código do boleto: </TextTitle>
                  <Input name="codigo_boleto" type="text" value={ateste.codigo_boleto} disabled />
                </Grid>
                <Grid xs={6}>
                  <TextTitle>Data de vencimento:</TextTitle>
                  <Input name="data_vencimento" type="date" value={ateste.data_vencimento} disabled />
                </Grid>
              </>
            ) : (
              <>
                <Grid xs={12}>
                  {ateste?.contractual_instrument?.tipo_instrumento == 'Convênios' ? (
                    <TextTitle>Conta bancária da empresa (convênio): </TextTitle>
                  )
                    : (
                      <TextTitle>Conta bancária da empresa: </TextTitle>
                    )}
                </Grid>
                <Grid xs={6} lg={3}>
                  <TextTitle>Tipo de conta:</TextTitle>
                  <Input
                    type="text"
                    id="tipoConta"
                    name="banco_tipo_conta"
                    value={ateste.banco_tipo_conta}
                    disabled
                  />
                </Grid>
                <Grid xs={6} lg={3}>
                  <TextTitle>Banco:</TextTitle>
                  <Input
                    type="text"
                    id="banco"
                    name="banco_nome"
                    value={ateste.banco_nome}
                    disabled
                  />
                </Grid>
                <Grid xs={6} lg={3}>
                  <TextTitle>Agência:</TextTitle>
                  <Input name="banco_agencia" type="text" value={ateste.banco_agencia} disabled />
                </Grid>
                <Grid xs={6} lg={3}>
                  <TextTitle>Conta:</TextTitle>
                  <Input name="banco_conta" type="text" value={ateste.banco_conta} disabled />
                </Grid>
              </>
            )}
          </Grid>
        </Panel>

        <Panel titulo="Objeto do pagamento">
          <Grid container spacing={6}>
            <Grid xs={12}>
              <TextTitle>Descrição:</TextTitle>
              <Textarea name="objeto_pagamento" defaultValue={ateste.objeto_pagamento} disabled />
            </Grid>
            <Grid xs={12}>
              <TextTitle>Medição:</TextTitle>
              <Textarea name="medicao" value={ateste.medicao} disabled />
            </Grid>
            <Grid xs={6}>
              <TextTitle>Número da nota Técnica:</TextTitle>
              <Input name="numero_nota_tecnica" type="text" value={ateste.numero_nota_tecnica} disabled />
            </Grid>
            <Grid xs={6}>
              <TextTitle>Nota Técnica:</TextTitle>
              <Link
                to={{
                  pathname: `${ateste?.url_arquivo}/${ateste?.nome_arquivo}`,
                }}
                target="_blank"
              >
                <ButtonDownloadArch name='selecionararquivo' type="button">
                  <FontAwesomeIcon icon={faDownload} size="1x" /> Download...
                </ButtonDownloadArch>
              </Link>
            </Grid>
          </Grid>
        </Panel>

        <Panel titulo="Rubrica orçamentária">
          <Grid container spacing={6}>
            <Grid xs={6}>
              <TextTitle>Valor total do ateste:</TextTitle>
              <span>R${ateste.valor_total}</span>
            </Grid>
            <Grid xs={12}>
              {ateste.attest_budgets?.length > 0 && processo?.id && (
                <SecondaryTable
                  columsData={dataTitleLinhas}
                  rowsData={organizeDataLinhas(ateste?.attest_budgets)}
                />
              )}
            </Grid>
          </Grid>
        </Panel>

        <Panel titulo="Nota Fiscal">
          <Grid container spacing={6}>
            {ateste.invoices?.length > 0 && processo?.id && (
              <>
                <Grid xs={12}>
                  <SecondaryTable
                    columsData={dataTitleNotaFiscal}
                    rowsData={organizeDataNotaFiscal(ateste?.invoices)}
                  />
                </Grid>
                <Grid xs={6}>
                  <TextTitle>Total: {formatarReais(ateste?.invoices?.reduce(function (acc, obj) { return acc + parseFloat(obj?.valor); }, 0))}</TextTitle>
                </Grid>
              </>
            )}
          </Grid>
        </Panel>

        <Panel titulo="Regularidade fiscal e trabalhista (data de validade das certidões)">
          <Grid container spacing={6}>
            <Grid xs={12}>
              {ateste.attest_supplier_certificates?.length > 0 && (
                <SecondaryTable
                  columsData={dataTitleCertidao}
                  rowsData={organizeDataCertidao(ateste.attest_supplier_certificates)}
                />
              )}
            </Grid>
          </Grid>
        </Panel>
      </Form>

      <ContainerButton2>
        <Link to="/financeiro/formularioateste">
          <button className="button_return">
            <FontAwesomeIcon icon={faChevronLeft} size="1x" /> Voltar
          </button>
        </Link>
        <Link to={`/financeiro/formularioateste/fichaPDF/${atesteId}`} target="_blank">
          <button className="button_save">
            <FontAwesomeIcon icon={faDownload} size="1x" /> Download PDF
          </button>
        </Link>
      </ContainerButton2>
    </Container>
  );
};

export default FinanceiroAtesteView;